export const env = {
    kataApiUrl: process.env.REACT_APP_KATA_API_URI,
}
